<template>
  <div ref="scrollRef"></div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from 'vue'

const props = defineProps({
  offset: {
    type: Number,
    required: false,
    default: 0,
  },
  rootId: {
    type: String,
    required: false,
    default: '',
  },
})
const emit = defineEmits(['leavingViewportAtTop', 'leavingViewportAtBottom', 'intersected'])

let observer: IntersectionObserver | null = null
const scrollRef = ref({})

onMounted(() => {
  const options = {
    root: props.rootId != '' ? document.getElementById(props.rootId) : null,
    rootMargin: `0px 0px ${props.offset}px 0px`,
  }
  try {
    observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.intersectionRect) {
        if (entry.intersectionRect.y === 0 && entry.boundingClientRect.top <= 0) {
          emit('leavingViewportAtTop')
        } else if (entry.intersectionRect.y === 0 && entry.boundingClientRect.top > 0) {
          emit('leavingViewportAtBottom')
        } else if (entry.intersectionRect.y > 0 && entry.boundingClientRect.top > 0) {
          emit('intersected')
        }
      }
    }, options)

    observer.observe(scrollRef.value as Element)
  } catch (error) {
    console.log('Observer error')
  }
})

onUnmounted(() => {
  observer?.disconnect()
})
</script>
